import { cn } from "@/lib/utils";

export const SubmitButton = ({
  children,
  loading,
  onClick,
  type = "submit",
  variant = "primary",
}: {
  children: React.ReactNode;
  loading?: boolean;
  onClick?: () => void;
  type?: "submit" | "button";
  variant?: "primary" | "secondary";
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={loading}
    className={cn(
      "w-full py-[0.8rem] rounded-lg border-none text-[0.9375rem] font-semibold cursor-pointer transition-opacity duration-150 disabled:opacity-60 disabled:cursor-not-allowed",
      variant === "primary"
        ? "bg-brand-pink text-white hover:opacity-[0.88]"
        : "bg-white text-[#374151] border border-[#E5E7EB] hover:bg-[#F3F4F6]",
    )}
  >
    {loading ? "Please wait…" : children}
  </button>
);
